import { Box, Typography } from "~/common/mui";
import { useTranslation } from "react-i18next";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
  query: string | undefined;
}
export const SearchQueryLabel = ({ query, ...rest }: Props) => {
  const { t } = useTranslation();
  const isDesktop = useIsMinDesktopSize();
  if (!query) {
    return null;
  }

  if (isDesktop) {
    return (
      <Typography {...rest} variant={"headlineLarge"}>
        {t("feature.search.searchedFor")}
        <strong> "{query}"</strong>
      </Typography>
    );
  }

  return (
    <Box {...rest}>
      {t("feature.search.searchedFor")}
      <br />
      <Typography component={"span"} sx={{ fontWeight: "bold" }} variant={"headlineSmall"}>
        "{query}"
      </Typography>
    </Box>
  );
};
